import apiClient from 'services/axios'
import routeNames from 'routeNames/backendRouteNames'

export default class AuthService {
  constructor() {
    this.apiClient = apiClient
    this.routeNames = routeNames
  }

  login = async ({ body }) => {
    return this.apiClient.post(this.routeNames.LOGIN.path, body)
  }

  getProfile = async () => {
    return this.apiClient.get(this.routeNames.GET_PROFILE.path)
  }

  updateProfile = async ({ body }) => {
    return this.apiClient.patch(this.routeNames.UPDATE_PROFILE.path, body)
  }

  getRoles = async () => {
    return this.apiClient.get(this.routeNames.GET_ROLES.path)
  }

  addDevice = async ({ body }) => {
    return this.apiClient.post(this.routeNames.ADD_DEVICE.path, body)
  }

  sendOtp = async ({ body }) => {
    return this.apiClient.post(this.routeNames.SEND_OTP.path, body)
  }
}
